/**
 * @file track-engagement.js
 * @description This script tracks clicks on engagement buttons on the webpage.
 * It sets up event listeners to handle clicks on anchor elements and dispatches a segment event.
 */
(function () {

  // add click listener for all engagement buttons
  document.addEventListener("click", function (e) {
    // get the a that was clicked
    const tagName = e.target.tagName.toLowerCase();
    const element = tagName === "a" ? e.target : e.target.closest("a");

    // if the element is not an anchor tag or doesn't have the btn class, return
    if (!element) {
      return;
    }

    // prevent tracking if the element is within the feature banner
    if (element.closest(".feature-banner")) {
      return;
    }

    // get the text of the element
    const text =
      tagName === "img"
      ? e.target.alt
      : element.textContent.trim() || "No text";

    // if the element does not have an href, return
    if (!element.hasAttribute("href")) {
      return;
    }

    // check if the links is not a google or apple play store link
    const storeMatch = element.href.match(
      /(play\.google\.com|apps\.apple\.com)/
    );

    const internalLinkMatch = isInternalLink(element.href);

    // if the link is not a store link or if it's an internal link, return
    if (!storeMatch && !internalLinkMatch) {
      return;
    }

    // if the link is internal but doesn't have the btn class, return
    if (internalLinkMatch && !element.classList.contains("btn")) {
      return;
    }

    // match if the link is an enter enrollment CTA
    const isEnterEnrollmentCta =
      (e.target.href &&
        e.target.href.match(
          /(member\.chime|test\.1debit)\.com\/(signup|enroll)/
        )) ||
      e.target.matches(".email-capture-submit");

    // or a home nav item
    const isHomeNavItem =
      (e.target.matches("#header .menu-item a") &&
        !e.target.matches(".apply a")) ||
      e.target.matches(".header__nav-btn--open");

    // if the link is a home nav item or an enter enrollment CTA, return
    if (isHomeNavItem || isEnterEnrollmentCta) {
      return;
    }

    const segmentAttributes = getModuleTrackingAttributes(element);

    // Extract module-related attributes
    const moduleData = extractModuleData(segmentAttributes);

    const destination = element.href;
    const location = window.location.href;

    const attributes = [
      ...segmentAttributes,
      ...convertObjectToArray({
        destination,
        label: text,
        button_name: text,
        cta_type: "engagement",
        ...getAdditionalTrackingProperties(),
      }),
    ];

    segmentGenericEvent("track", {
      interaction_type: "INTERACTION_TYPE_ENGAGEMENT_LINK_TAPPED",
      interaction_details: {
        location: location,
        action_detail: text,
      },
      additional_data: attributes,
    });

    // Analytics SDK double fire
    fireAnalyticsEvent(Track.WebItemClicked, {
      unique_id: 'engagement_link',
      label: text,
      element_type: 'ELEMENT_TYPE_LINK',
      item_value: destination,
      item_details: {
        "engagement_link": {
          "module": {
            ...moduleData,
          },
          "cta_type": "engagement",
        }
      }
    });
  });
})();
